<template>
    <div id="login-settings"
         class="modl-tab-body">
        <div class="modl-body">
            <form v-if="settings"
                  class="form-h"
                  @submit.prevent="submit">
                <div v-if="showEntraIDSetting"
                     class="form-group">
                    <label class="control-label">
                        {{ l('LOGIN_SETTINGS.SHOW_ENTRA_ID') }}
                    </label>
                    <div class="form-h__right">
                        <BooleanToggleButtons v-model="settings.showEntraID"></BooleanToggleButtons>
                    </div>
                </div>
            </form>
        </div>

        <div class="modl-footer">
            <!-- Cancel button -->
            <button class="btn btn-lg btn-default cancel-btn"
                    @click.prevent="$emit('cancel')">
                {{ l('CANCEL') }}
            </button>

            <!-- OK button -->
            <button class="btn btn-lg btn-primary"
                    :disabled="saving"
                    @click.prevent="submit">
                <i v-if="saving"
                   class="fa-solid fa-spinner fa-spin" />
                <template v-else>
                    {{ l('SAVE') }}
                </template>
            </button>
        </div>
    </div>
</template>

<script>
import BooleanToggleButtons from '@/epos/vue/modals/Settings/components/BooleanToggleButtons';
import LocalStorageKeys from '@/lib/Storage/LocalStorageKeys';
import LoginSettings from '@/lib/Auth/LoginSettings';
import { container } from '@/container';

export default {
    components: { BooleanToggleButtons },

    emits: [
        'cancel',
        'resolve',
    ],

    data() {
        return {
            saving: false,

            /**
             * @type {boolean}
             */
            showEntraIDSetting: false,

            /**
             * @type {LoginSettings}
             */
            settings: null,
        };
    },

    created() {
        this.loadSettings();

        if (container.appConfig.entraIDLoginEnabled === null) {
            container.entraIDAuthService.entraIDAppExistsForCurrentEnvironment()
                .then((result) => {
                    this.showEntraIDSetting = result;
                });
        }
    },

    methods: {
        loadSettings() {
            this.settings = new LoginSettings(container.localStorageDataStore.find(LocalStorageKeys.LOGIN_SETTINGS) || {});
        },

        submit() {
            container.localStorageDataStore.persist(LocalStorageKeys.LOGIN_SETTINGS, this.settings);
            this.$emit('resolve');
        },
    },
};
</script>
